/**
 * Scroll Utilities
 * 
 * Centralized functions for smooth scrolling behavior across the application.
 * Provides consistent scroll animations and element targeting.
 * 
 * @module utils/scroll
 */

/**
 * Smoothly scrolls to an element by its ID
 * 
 * @param elementId - The ID of the target element (without the # prefix)
 * @param behavior - Scroll behavior (default: 'smooth')
 * 
 * @example
 * ```tsx
 * scrollToElement('contact');
 * scrollToElement('services', 'auto');
 * ```
 */
export const scrollToElement = (
  elementId: string,
  behavior: ScrollBehavior = 'smooth'
): void => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior });
  }
};

/**
 * Scrolls to the contact section
 * Convenience wrapper for the most common scroll action
 */
export const scrollToContact = (): void => {
  scrollToElement('contact');
};

/**
 * Scrolls to the services section
 * Convenience wrapper for services navigation
 */
export const scrollToServices = (): void => {
  scrollToElement('services');
};
